// extracted by mini-css-extract-plugin
export var equalColumn = "_fc-0";